import { AxiosResponse } from "axios"
import { useQuery } from "react-query"
import { toast } from "react-toastify"

import reportService from "api/reportService"
import { IGetReportQueryParams } from "types/report"

export interface IUseGetReportProps {
  previewQuery: IGetReportQueryParams
  enabled: boolean
}

const useGetReportPreview = ({ previewQuery, enabled }: IUseGetReportProps) => {
  return useQuery(
    ["reportPreview"],
    async () => {
      const res: AxiosResponse<any> = await reportService.getReportPreview(
        previewQuery,
      )

      return res.data
    },
    {
      enabled,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onError: (err) => {
        toast.error("Internal Server Error")
      },
    },
  )
}

export default useGetReportPreview
